import React from "react";
import {connect} from "react-redux";
import {updatePanelMode} from "../../actions/account";
import {Radio} from "antd";

class PanelModeToggle extends React.Component {
    render() {
        return <Radio.Group size='small' style={{width: '100%'}} defaultValue={this.props.user.user.panel_mode} onChange={(e) => {
            this.props.updatePanelMode({'panel_mode': e.target.value}, () => {
                window.location.reload();
            })
        }}>
            <Radio.Button value="SIMPLE">Simple</Radio.Button>
            <Radio.Button value="ADVANCED">Advanced</Radio.Button>
        </Radio.Group>;
    }
}
const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps, { updatePanelMode })(PanelModeToggle);